import {DateTime} from 'luxon'

export default (value?: DateTime) => {
  if(!value) return ''
  return value.toFormat('yyyy년 M월 d일')
}
